export enum ClassRoomErrorCodes {
  CannotBeLeaved = "CANNOT_BE_LEAVED",
}
